import { createElement, forwardRef } from 'react';
import { visuallyHidden } from '../patterns/visually-hidden.mjs';
import { splitProps } from '../helpers.mjs';
import { styled } from './factory.mjs';

export const VisuallyHidden = /* @__PURE__ */ forwardRef(function VisuallyHidden(props, ref) {
  const [patternProps, restProps] = splitProps(props, visuallyHidden.propKeys)
  const styleProps = visuallyHidden.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})